import React from "react";
import { BusinessCreditReportStatePII, IActiveJudgement } from "../../../../store/businessCreditReportService/types";
import { toggle } from "../../../../util/common";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const LegalFilingsActiveJudgements: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-leagal-filings-active-judgements"
                            onClick={(e) => toggle("leagal-filings-active-judgements-div", "btn-leagal-filings-active-judgements")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> Active Judgements
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Active Judgements</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="leagal-filings-active-judgements-div"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        {props.reportObject?.businessCompanyReport?.active_judgements?.map((activeJudgement: IActiveJudgement, index: number) => (
                            <React.Fragment key={`active-judgement-${index}`}>
                                <div role="grid" className="data-grid row-height-xs " aria-labelledby="btn-leagal-filings-active-judgements">
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-judgements-date-filed-${index}`}>
                                                Date Filed
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-judgements-filing-type-${index}`}>
                                                Filing Type
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-judgements-case-number-${index}`}>
                                                Case Number
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-judgements-date-filed-${index}`}>
                                                {activeJudgement?.date_filed}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-judgements-filing-type-${index}`}>
                                                {activeJudgement?.filing_type}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-judgements-case-number-${index}`}>
                                                {activeJudgement?.case_number}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-judgements-amount-${index}`}>
                                                Amount
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-judgements-plaintiff-${index}`}>
                                                Plaintiff
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-judgements-blank-${index}`}></div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-judgements-amount-${index}`}>
                                                {activeJudgement?.amount}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-judgements-plaintiff-${index}`}>
                                                {activeJudgement?.plaintiff}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-judgements-blank-${index}`}></div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LegalFilingsActiveJudgements;
